export default __webpack_public_path__ + "static/media/Illustrator.3275990f.png";